import styled from 'styled-components';

const Error = styled.div`
  color: crimson;
  margin-top: 20px;
`;

export default Error;



// WEBPACK FOOTER //
// ./src/components/RecipeForm/styled/Error.js